import { Colors } from '@cognite/cogs.js';
import { Cascader } from 'antd';
import { CascaderProps } from 'antd/lib/cascader';
import { Icon } from 'components/Icon';
import { useState } from 'react';
import styled from 'styled-components/macro';

export const CascaderSelect = (props: CascaderProps<any>) => {
  const [focused, setFocused] = useState(false);
  return (
    <StyledCascaderContainer>
      <Cascader
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        suffixIcon={
          focused ? <Icon type="ChevronUp" /> : <Icon type="ChevronDown" />
        }
        {...props}
      />
    </StyledCascaderContainer>
  );
};

const StyledCascaderContainer = styled.div`
  width: 100%;
  .ant-select-focused:not(.ant-select-disabled).ant-select:not(
      .ant-select-customize-input
    ) {
    .ant-select-selector {
      border: 2px solid ${Colors['border--interactive--default']};
      box-shadow: unset;
      outline: 0;
    }
  }
  .ant-cascader {
    width: 100%;
    &:not(.ant-select-disabled):hover {
      .ant-select-selector {
        border-color: ${Colors['decorative--grayscale--400']};
        border: 2px solid ${Colors['decorative--grayscale--400']};
      }
    }
    .ant-select-selector {
      height: 36px;
      border-radius: var(--cogs-border-radius--default);
      border: 2px solid ${Colors['decorative--grayscale--400']};
      transition: border var(--cogs-transition-time-fast) linear;
      input {
        border: 0;
        outline: none;
      }
    }
    &.ant-select-disabled {
      .ant-select-arrow {
        color: ${Colors['border--interactive--disabled']};
      }
    }
    .ant-select-arrow {
      transform: translateY(-50%);
      margin-top: 0;
      width: 16px;
      height: 16px;
      color: ${Colors['decorative--grayscale--600']};
    }
  }
  .ant-select-dropdown {
    border-radius: var(--cogs-border-radius--default);
  }
  .ant-cascader-menu-item-active {
    background: var(--cogs-bg-selected);
  }
  .ant-cascader-menu-item-keyword {
    color: var(--cogs-text-accent);
  }
`;
